import { dashboardUrl, signInUrl } from './siteHost';

/** Absolute or same-origin sign-in URL (app subdomain in production). */
export function getSignInHref(): string {
  return signInUrl();
}

export function getDashboardHref(): string {
  return dashboardUrl();
}
